import { Button } from "@shared/ui/button";
import { TooltipProvider } from "@shared/ui/tooltip";
import { Plus } from "lucide-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logEvent } from "@shared/analytics/analytics";
import { NetworksKpiCards } from "./NetworksKpiCards";
import { NetworksTable } from "./NetworksList";
import { PageHeader } from "@shared/components/PageHeader";

const Landing: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    logEvent("Networks Page Viewed", {});
  }, []);
  const handleAddNetwork = () => {
    logEvent("Networks Add New Clicked", {});
    navigate("/ax/asset-registry/networks/create/add");
  };

  const handleAddBulk = () => {
    logEvent("Networks Bulk Add Clicked", {});
    navigate("/onboarding/data-migration/data-cards");
  };

  return (
    <TooltipProvider>
      <div>
        <div className="space-y-6">
          {/* Header with buttons */}
          <div className="flex justify-between items-center">
            <PageHeader
              title="Networks"
              subtitle="Manage and monitor your water distribution network infrastructure"
            />
            <div className="flex gap-3">
              <Button variant="outline" onClick={handleAddBulk}>
                <Plus className="h-4 w-4 mr-2" />
                Bulk Add
              </Button>
              <Button onClick={handleAddNetwork}>
                <Plus className="h-4 w-4 mr-2" />
                Add New Network
              </Button>
            </div>
          </div>

          {/* KPI Cards */}
          <NetworksKpiCards />

          {/* Networks Table */}
          <NetworksTable />
        </div>
      </div>
    </TooltipProvider>
  );
};

export default Landing;
